import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import icons from "./iconset-all_maki_icons.json";
export const allIcons = Object.keys(icons.iconGroups[0].svgs).map(iconId => iconId.replace(".svg", ""));
export function isMakiIcon(id) {
  if (!id) return;
  const svgId = "".concat(id, ".svg");
  const iconSvgs = icons.iconGroups[0].svgs;
  return svgId in iconSvgs;
}

/** Get SVG string for maki icon */
export function getMakiIcon(id, color, strokeWidth, strokeColor, height, width) {
  if (id === "point") id = "circle";
  const svgId = "".concat(id, ".svg");
  const iconSvgs = icons.iconGroups[0].svgs;
  if (svgId in iconSvgs) {
    if (!strokeColor || !strokeWidth) strokeWidth = 0;

    // Values are adapted from https://labs.mapbox.com/maki-icons/editor/
    const path = iconSvgs[svgId].pathData[0].d;
    const totalHeight = height + 4 + strokeWidth * 2;
    const totalWidth = width + 4 + strokeWidth * 2;
    const translate = Math.floor(2 + strokeWidth);
    const scaleHeight = height / 15;
    const scaleWidth = width / 15;
    return "data:image/svg+xml;base64,".concat(btoa("<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 ".concat(totalHeight, " ").concat(totalWidth, "\" height=\"").concat(totalHeight, "\" width=\"").concat(totalWidth, "\"><title>").concat(svgId, "</title><rect fill=\"none\" x=\"0\" y=\"0\" width=\"").concat(totalWidth, "\" height=\"").concat(totalHeight, "\"></rect>\n      ").concat(strokeWidth > 0 ? "<path fill=\"".concat(strokeColor, "\" transform=\"translate(").concat(translate, " ").concat(translate, ") scale(").concat(scaleWidth, " ").concat(scaleHeight, ")\" d=\"").concat(path, "\" style=\"stroke-linejoin:round;stroke-miterlimit:4;\" stroke=\"").concat(strokeColor, "\" stroke-width=\"").concat(strokeWidth, "\"></path>") : "", "\n      <path fill=\"").concat(color, "\" transform=\"translate(").concat(translate, " ").concat(translate, ") scale(").concat(scaleWidth, " ").concat(scaleHeight, ")\"  d=\"").concat(path, "\" ></path></svg>")));
  }
}